export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9625.8e4de3c2.jpg";